import { defineAction } from '~/prix'
import { z } from 'zod'
import { communityGardenDocumentStatus } from '../communityGardenDocumentObject'
import communityGardenDocumentConfirmAction from './communityGardenDocumentConfirm.action.json' with { type: 'json' }

const communityGardenDocumentConfirmDefinition = defineAction({
  ...communityGardenDocumentConfirmAction,

  input: z.object({
    id: z.string().uuid(),
    status: communityGardenDocumentStatus,
  }),
  output: z.object({}),
})

export default communityGardenDocumentConfirmDefinition
